import styled from 'styled-components';

export const VersionWrapper = styled.div`
`;

export const VersionLabelText = styled.span`
    color: var(--neutral-color-gray-9, #434343);
    font-size: 13px;
    font-family: Roboto, sans-serif;
    font-weight: 500;
    opacity: 0.9;
    white-space: nowrap; 
`;